import store from "../store/index.js";

export const getReduxValue = (path) => {
  // path as string "auth.accessToken"
  const keys = path.split(".");
  let value = store.getState();
  for (const key of keys) {
    if (value[key] === undefined) return undefined;
    value = value[key];
  }
  return value;
};

export const setReduxValue = (path, value) => {
  const [slice, field] = path.split(".");
  store.dispatch({
    type: `${slice}/set${field.charAt(0).toUpperCase() + field.slice(1)}`,
    payload: value,
  });
};

export const clearReduxValue = (path) => {
  const [slice, field] = path.split(".");
  store.dispatch({
    type: `${slice}/clear${field.charAt(0).toUpperCase() + field.slice(1)}`,
  });
};
